import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatProgressSpinnerModule } from '@angular/material';

import { SharedModule } from '../../shared';
import { HomeMaterialModule } from '../home-material/home-material.module';
import { RewardsComponent } from './rewards.component';
import { RewardSummaryCardsComponent } from './reward-summary-cards/reward-summary-cards.component';
import { RewardTransactionTabsComponent } from './reward-transaction-tabs/reward-transaction-tabs.component';
import { ExpiringPointsComponent } from './expiring-points/expiring-points.component';
import { PrizeDrawingModalComponent } from './prize-drawing-modal/prize-drawing-modal.component';
import { RewardPointsTabComponent } from './reward-transaction-tabs/points-tab/reward-points-tab.component';
import { RewardTicketsTabComponent } from './reward-transaction-tabs/tickets-tab/reward-tickets-tab.component';
import { RewardCashTabComponent } from './reward-transaction-tabs/cash-tab/reward-cash-tab.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    SharedModule,
    HomeMaterialModule,
    MatProgressSpinnerModule,
  ],
  declarations: [
    RewardsComponent,
    RewardSummaryCardsComponent,
    RewardTransactionTabsComponent,
    ExpiringPointsComponent,
    PrizeDrawingModalComponent,
    RewardPointsTabComponent,
    RewardTicketsTabComponent,
    RewardCashTabComponent,
  ],
  exports: [
    RewardsComponent,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA,
  ],
})
export class RewardsModule { }
